import Swiper, {Navigation, Scrollbar, Controller, Autoplay} from "swiper";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";

export default () => {
	const sliderLeftLenght = document.querySelectorAll(".block.block--slider .sliders .swiper--left .swiper-slide").length - 1

	const SliderLeft =
		new Swiper(".block.block--slider .sliders .swiper--left", {
			direction: 'vertical',
			slidesPerView: 1,
			allowTouchMove: false,
			initialSlide: sliderLeftLenght,
		});

	new Swiper(".block.block--slider .sliders .swiper--right", {
		modules: [Navigation, Scrollbar, Controller],
		direction: 'vertical',
		slidesPerView: 1,
		allowTouchMove: false,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		scrollbar: {
			el: ".swiper-scrollbar",
			draggable: true,
		},
		controller: {
			control: SliderLeft,
			inverse: true,
		}
	});

	new Swiper(".block.block--slider .slider--mobile .swiper", {
		modules: [Autoplay],
		slidesPerView: 1,
		loop: true,
		autoplay: {
			delay: 2500,
		},
	});
};
